<template>
  <div class="choose" style="margin-top: 15px;">
  	<div class="container" style="background-color: #fff;">
  		<div class="title">
  			{{categoryName}}
  		</div>
  		<div class="smallTitle">
  			请您点击下列考试科目名称，进入机考模拟系统界面！
  		</div>
  		<div class="line">

  		</div>
  		<div class="listWrap flex">
  			<div class="list" v-for="item in list" @click="handleOnlineTest(item.categoryId,item.categoryName)">
  				<span class="name">{{item.categoryName}}</span>
  				<span class="cart"><img src="../assets/img/cart.png" ></span>
  			</div>



  		</div>
  <!-- 		<div class="listWrap flex">
  			<div class="list">
  				<span class="name">财务管理</span>
  				<span class="cart"><img src="../assets/img/cart.png" ></span>
  			</div>
  			<div class="list">

  			</div>
  			<div class="list">

  			</div>


  		</div> -->
  	</div>
  </div>
</template>

<script>
  import bus from '../assets/utils/eventBus.js';
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
        list:[],
        id:this.$route.query.id,
        categoryName:this.$route.query.categoryName
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.categorys_twoClassify+'?classifyId='+this.$route.query.id).then((res)=>{
              if(res.data.code==1){

                  this.list=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleOnlineTest(categoryId,categoryName){

        bus.$emit('checkBuy',{categoryId:categoryId,parentId:this.id,categoryName:categoryName});
        let data=new FormData();
            data.append('oneCategoryId',this.id);
            data.append('twoCategoryId',categoryId);
        this.$axios.post(this.$common.login_accountCategory,data).then((res)=>{
              if(res.data.code==1){

                      this.$router.push('homeworklist');
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created() {
      this.getData();
    },
    watch:{
       '$route' (to, from) {
          // data数据操作
          this.getData();
        }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/choose.vue